export default __webpack_public_path__ + "static/spiritual-india-people-3-105b20a848f93ed2f073db5fc21a4f8a.jpg";